import axios from "axios";
import { API_URL } from "src/scenes/App";
import { DirectoryContactPayload } from "../directoryCsv";

export interface CreatedDirectoryContact {
    uuid: string;
    [key: string]: unknown;
}

interface CreateDirectoryContactResponse {
    contacts: CreatedDirectoryContact[];
}

export const createDirectoryContacts = async (
    token: string,
    contacts: DirectoryContactPayload[]
): Promise<CreatedDirectoryContact[]> => {
    const response = await axios.post<CreateDirectoryContactResponse>(
        `${API_URL}/businessContacts/csv`,
        contacts,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data.contacts;
};
